<template>
  <div>
    <br />
    <el-form
      ref="dataForm"
      :inline="true"
      :model="dataForm"
      @submit.native.prevent
      @keyup.enter.native="querySearch()"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item prop="name">
            <el-input
              v-model="dataForm.name"
              placeholder="请输入设备名称关键词"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                pageIndex = 1
                getDataList()
              "
              >查询</el-button
            >
            <el-button @click="refreshForm()">重置</el-button>
            <el-button type="danger" @click="addEquipment()">
             新增</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="dataList" v-loading="tabLoding" border style="width: 100%">
      <el-table-column
        prop="deviceName"
        header-align="center"
        align="center"
        label="设备名称"
      >
      </el-table-column>
      <el-table-column
        prop="uniqueAddress"
        header-align="center"
        align="center"
        label="设备唯一凭证"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        header-align="center"
        align="center"
        label="备注"
      >
      <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editHandle(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
            v-if="scope.row.perm !== 'admin'"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div v-if="totalPage > 0">
      <el-pagination
        class="mt-sm"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <add-equipment
      v-if="addVisible"
      ref="addModal"
      @refreshDataList="getDataList"
    ></add-equipment>
  </div>
</template>

<script>
import AddEquipment from './AddEquipment.vue'
import httpMethods from '@/api/equipment/http.js'

export default {
  data() {
    return {
      dataForm: {
        name: ''
      },
      proId: '', // 产品id
      addVisible: false,
      tabLoding: false,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataList: []
    }
  },
  components: {
    AddEquipment
  },

  mounted() {
    const search = location.hash.split('?proId=')[1]
    this.proId = search.split('&proName=')[0]
    this.querySearch()
  },
  methods: {
    querySearch() {
      this.pageIndex = 1
      this.getDataList()
    },
    // 查询
    getDataList() {
      const params = {
        currentPage: this.pageIndex,
        size: this.pageSize,
        productId: this.proId,
        deviceName: this.dataForm.name
      }
      httpMethods
        .getDataList(params)
        .then((res) => {
          const data = res.data
          if (data && res.resp_code === 0) {
            if (data.list.length === 0 && data.total > 0) {
              this.pageIndex = this.pageIndex - 1
              this.getDataList()
            } else {
              this.dataList = data.list
              this.totalPage = data.total
            }
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.tabLoding = false
        })
        .catch(() => {
          this.dataList = []
          this.totalPage = 0
          this.tabLoding = false
        })
    },

    // 重置
    refreshForm() {
      this.$refs.dataForm.resetFields()
      this.pageIndex = 1
      this.getDataList()
    },
    // 新增
    addEquipment() {
      this.addVisible = true
      this.$nextTick(() => {
        this.$refs.addModal.init('', this.proId)
      })
    },
    // 编辑
    editHandle(info) {
      this.addVisible = true
      this.$nextTick(() => {
        this.$refs.addModal.init(info)
      })
    },
    // 删除 后续需修改
    deleteHandle(id) {
      this.$confirm('确认进行删除操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteSure(id)
        })
        .catch(() => {})
    },
    deleteSure(id) {
      const data = {
        id: id
      }
      httpMethods
        .delEquipment(data)
        .then((res) => {
          if (data && res.resp_code === 0) {
            this.getDataList()
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {})
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
